import axios from "axios";

const apiUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api"
    : null);

if (!apiUrl) {
  throw new Error(
    "REACT_APP_API_URL es obligatoria en producción",
  );
}

const API = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

API.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin");
    }

    return Promise.reject(error);
  },
);

export default API;